import { CompanyProfile } from '@mkp/company/models';
import { ApiLink } from '@mkp/shared/models';
import { createAction, props } from '@ngrx/store';
import { QueryOptions } from '@mkp/shared/util-pagination';

export const ActionTypes = {
  RESET_COMPANY_PROFILE: '[Company Profile] Reset Company Profile',
  COMPANY_GET_PROFILE_LIST: '[Company Profile] Companies Profile List',
  COMPANY_GET_PROFILE_LIST_SUCCEEDED: '[Company Profile] Companies Profile List Succeed',
  COMPANY_GET_PROFILE_LIST_FAILED: '[Company Profile] Companies Profile List Failed',
};

// Reset Company Profile List
export const ResetCompanyProfile = createAction(ActionTypes.RESET_COMPANY_PROFILE);

// Get Company Profile List
export const CompanyGetProfileList = createAction(
  ActionTypes.COMPANY_GET_PROFILE_LIST,
  props<{ query?: QueryOptions }>()
);

export const CompanyGetProfileListSuccess = createAction(
  ActionTypes.COMPANY_GET_PROFILE_LIST_SUCCEEDED,
  props<{
    companyProfiles: CompanyProfile[];
    _links: Record<string, ApiLink>;
    filter: string;
    totalCount: number;
  }>()
);

export const CompanyGetProfileListFailure = createAction(
  ActionTypes.COMPANY_GET_PROFILE_LIST_FAILED,
  props<{ error: { message: string } }>()
);
